
<template>
     <div @click="goToFrontPage" class="left-box">
      <img src="./img/fhsyj.png" alt="" style="width: .5625rem;height: 1rem;">
    </div>

  <div ref="chartDom" style="width: 25rem; height: 20rem;"></div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import * as echarts from 'echarts';
import { useRouter } from 'vue-router'
const router = useRouter()
import { getechartsdata } from '@/services/service'
const route = useRouter().currentRoute.value;
const chartDom = ref(null);
let chartInstance = null;
const user_id = ref(null);
user_id.value = route.query.id;

const userDetailMessage = ref(null);
// 初始化图表
const initChart = () => {
  chartInstance = echarts.init(chartDom.value);

  const option = {
  xAxis: {
    type: 'category',
  
  },
  yAxis: {
    type: 'value',
    min: userDetailMessage.value.min, // 设置最小值
    max: userDetailMessage.value.max, // 设置最大值
  },
  series: [
    {
      data: userDetailMessage.value.data,
      type: 'line'
    }
  ]
};
  chartInstance.setOption(option);
};

onMounted(async () => {
  try {
    userDetailMessage.value = await getechartsdata(user_id.value)
    console.log(userDetailMessage);
  } catch (error) {
    console.error('获取用户详情失败:', error)
  }
  initChart();
});

const goToFrontPage = () => {
  router.push({
        path: '/matchpage',
        query: {
            id:user_id.value,
        },
        replace: false
    })
}
onBeforeUnmount(() => {
  chartInstance.dispose(); // 销毁图表实例
});
</script>

<style scoped lang="less">
.left-box {
    width: 100%;
    height: 2.5rem;
    margin-left: 0.5rem;
    display: flex;
    align-items: center;
  }
  
@media screen and (max-width: 1000px) {
  .chart-container {
    transform: rotate(-90deg);
    transform-origin: left top;
    width: 100vh;
    height: 100vw;
  }
}
</style>